import { ReactNode } from "react";
import { Text } from "@otrium/atoms";
import { Box } from "@otrium/core";
import {
  SocialEmailIcon,
  SocialAppleIcon,
  GoogleIcon,
  SocialFbIcon,
} from "src/icons";
import { SocialIconButton } from "./SocialButton.styled";

type SocialBtnType = "facebook" | "google" | "apple" | "email";

type SocialButtonProps = {
  type: SocialBtnType;
  fullWidth?: boolean;
  width?: string;
  noWrapper?: boolean;
  "data-testid"?: string;
  onClick: () => void;
  children?: ReactNode;
};

const icons = {
  facebook: <SocialFbIcon width={32} />,
  google: <GoogleIcon width={32} />,
  apple: <SocialAppleIcon width={32} />,
  email: <SocialEmailIcon width={32} />,
} satisfies Record<SocialBtnType, JSX.Element>;

function SocialButton({
  type,
  onClick,
  children,
  fullWidth,
  width,
  noWrapper,
  "data-testid": dataTestId,
  ...rest
}: SocialButtonProps): JSX.Element {
  return noWrapper ? (
    <SocialIconButton
      variant="tertiary"
      onClick={onClick}
      data-testid={dataTestId}
      fullWidth={fullWidth}
      leftIcon={icons[type]}
      {...rest}
    >
      {children && (
        <Text
          width="80px"
          textAlign="left"
          fontSize={1}
          fontWeight="600"
          as="span"
        >
          {children}
        </Text>
      )}
    </SocialIconButton>
  ) : (
    <Box mt={3} width={fullWidth ? "100%" : width}>
      <SocialIconButton
        variant="tertiary"
        onClick={onClick}
        data-testid={dataTestId}
        fullWidth={fullWidth}
        leftIcon={icons[type]}
        {...rest}
      >
        {children && (
          <Text
            width="80px"
            textAlign="left"
            fontSize={1}
            fontWeight="600"
            as="span"
          >
            {children}
          </Text>
        )}
      </SocialIconButton>
    </Box>
  );
}

export default SocialButton;
